import { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';

import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';

class ModalUserAddOrUpdateInternal extends Component {
    state = {
        userId: "",
        name: "",
        description: "",
        username: "",
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\"";
        
        this.nameValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        this.setState(
            {
                userId: isUpdate ? this.props.userToUpdate.userId : "",
                name: isUpdate ? this.props.userToUpdate.name : "",
                description: isUpdate ? this.props.userToUpdate.description : "",
                username: isUpdate ? this.props.userToUpdate.username : "",
            }
        );
    }

    handleDoneButtonClicked = () => {
        const trimmedName = this.state.name.trim();
        const trimmedDescription = this.state.description.trim();

        const doneInfo = {
            userId: this.state.userId,
            name: trimmedName,
            description: trimmedDescription,
            username: this.state.username,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleCancelButtonClicked = () => {
        this.props.onHide();
    }

    handleNameChanged = (e) => {
        const updatedName = e.target.value;

        if (updatedName.length > 0 && !this.nameValidationRegex.test(updatedName)) {
            return;
        }
                
        this.setState({
            name: updatedName
        });
    }

    handleDescriptionChanged = (e) => {
               
        this.setState({
            description: e.target.value
        });
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.name === '') {
            return "Name may not be empty";
        }

        if (this.state.name.length > 50) {
            return "Name must be less than 50 characters";
        }

        if (this.state.description.length > 256) {
            return "Description must be less than 256 characters";
        }

        if (this.state.name !== this.props.userToUpdate.name ||
            this.state.description !== this.props.userToUpdate.description) { 
                return null;
        }

        return "No changes detected";
    }

    render() {
        const headerText = this.props.isUpdate ? 'Update User' : 'Add User';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newUserName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" value={this.state.name} autoComplete="off" onChange={this.handleNameChanged} />
                    </Form.Group>
                    <Form.Group controlId="newUserDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter description" value={this.state.description} autoComplete="off" onChange={this.handleDescriptionChanged} />
                    </Form.Group>
                    {this.props.isUpdate ? <Form.Group controlId="newUserSipUsername">
                        <Form.Label>Username</Form.Label>
                        <Form.Control type="text" disabled={true} value={this.state.username} />
                    </Form.Group> : null}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalUserAddOrUpdate = (props) => {
    return (
        <ModalUserAddOrUpdateInternal {...props}/>
    )
}